import { createState } from '~/util/storeHelpers'

const rejectBonusStore = createState({ key: 'rejectBonus', initialValue: '' })
const activateBonusStore = createState({ key: 'activateBonus', initialValue: '' })
const availableBonusesStore = createState({ key: 'availableBonuses', initialValue: '' })

export const state = () => ({
  rejectBonus: rejectBonusStore.state,
  activateBonus: activateBonusStore.state,
  availableBonuses: availableBonusesStore.state,

  depositBonusData: {},
})
export const mutations = {
  set_rejectBonus: rejectBonusStore.setter,
  set_activateBonus: activateBonusStore.setter,
  set_availableBonuses: availableBonusesStore.setter,

  set_depositBonusData(state, payload) {
    state.depositBonusData = payload
  },
}
export const actions = {
  async reject_bonus({ commit }, { promotion }) {
    commit('set_rejectBonus', { isLoading: true })
    try {
      const res = await this.$api.userPromotions.cancel({ promotion })
      commit('set_rejectBonus', { data: res.data })
    }
    catch (e) {
      commit('set_rejectBonus', { error: e })
    }
    finally {
      commit('set_rejectBonus', { isLoading: false })
    }
  },
  async activate_bonus({ commit }, { promotion_code }) {
    commit('set_activateBonus', { isLoading: true })
    try {
      const res = await this.$api.userPromotions.activate({ promotion_code })
      commit('set_activateBonus', { data: res.data })
    }
    catch (e) {
      commit('set_activateBonus', { error: e })
    }
    finally {
      commit('set_activateBonus', { isLoading: false })
    }
  },
  async fetch_availableBonuses({ commit, getters }) {
    if (getters.get_availableBonuses.isLoading) return
    commit('set_availableBonuses', { isLoading: true })
    try {
      const res = await this.$api.userPromotions.getPromotionsAvailable()
      commit('set_availableBonuses', { data: res.data })
    }
    catch (e) {
      commit('set_availableBonuses', { error: e })
    }
    finally {
      commit('set_availableBonuses', { isLoading: false })
    }
  },
  transfer_depositBonus({ commit }, { code, bonusSum, isFromBonusePage }) {
    const payload = {
      ...(code && { code }),
      ...(bonusSum && { bonusSum }),
      ...(isFromBonusePage && { isFromBonusePage }),
    }

    commit('set_depositBonusData', payload)
  },
}
export const getters =  {
  get_rejectBonus: rejectBonusStore.getter,
  get_activateBonus: activateBonusStore.getter,
  get_availableBonuses: availableBonusesStore.getter,

  get_depositBonusData: state => state.depositBonusData,
}
